export interface Tag {
  id: number;
  name: string;
  assignId?: number | null;
  active?: boolean | null;
}

export class Tag implements Tag {
  id;
  name;
  active?: boolean | null;

  constructor(config: Tag) {
    this.id = config.id;
    this.name = config.name;
    this.active = config.active;
  }
}

export class AssignedTag extends Tag {
  assignId: number | null;

  constructor(config: Tag) {
    super(config);
    this.assignId = config.assignId || null;
  }
}
